module.exports = __webpack_public_path__ + "static/media/insurance-sticker.4de0b6d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/insurance-sticker.png
// module id = 445
// module chunks = 0